import { isSameRange } from './isSameRange'

interface RangesInNode {
  node: Node
  ranges: Range[]
}

export function persistRangeReference(target: RangesInNode, cache: RangesInNode[]) {
  const cached = cache.find((cached) => cached.node === target.node)
  if (!cached) {
    return target
  }

  return {
    node: target.node,
    ranges: target.ranges.map(
      (range) => cached.ranges.find((cachedRange) => isSameRange(cachedRange, range)) ?? range,
    ),
  }
}
